module.exports = __webpack_public_path__ + "img/memberWhite.49d688a4.svg";